export function NoIcon(): null {
  return null;
}
